import { useFilterContext } from '../contexts/FilterContext';
import { snakeToTitleCase } from '../utils/String';

/**
 * Human-readable labels for the current model's KPI metric.
 *
 * KPI metrics are dynamic (any numeric column of the customer's KPI sheet),
 * so chart titles and legends must not hardcode "Sales"/"Conversions".
 * Falls back to the historical domain term for legacy model versions that
 * don't carry kpiMetric: 'Sales' on MM dashboards, 'Conversions' on DA.
 *
 * For the sales metric the MM outputs match the historical copy exactly:
 * 'Sales' / 'Incremental sales' / 'Predicted sales'.
 */
export const useKpiMetricLabels = () => {
  const { currentModelVersion } = useFilterContext();

  const fallback =
    currentModelVersion?.modelType === 'da' ? 'Conversions' : 'Sales';
  const metricLabel = currentModelVersion?.kpiMetric
    ? snakeToTitleCase(currentModelVersion.kpiMetric)
    : fallback;
  const lowercased = metricLabel.toLowerCase();

  return {
    /** e.g. 'Sales', 'New Subscriptions' */
    metricLabel,
    /** e.g. 'Incremental sales', 'Incremental new subscriptions' */
    incrementalLabel: `Incremental ${lowercased}`,
    /** e.g. 'Predicted sales', 'Predicted new subscriptions' */
    predictedLabel: `Predicted ${lowercased}`,
  };
};
